module.exports = __webpack_public_path__ + "img/truewallet.67be3b22.png";